module.exports = __webpack_public_path__ + "img/121ne.9fb3b8e2.svg";